import { useEffect, useState } from 'react';
import { BASE_URL, UPLOAD_IMAGES } from '../utils/constants';
import { get, getBlob } from '../utils/axios-config';
import { useIES } from './useIES';

export function useLogoBase64() {
  const [logoBase64, setLogoBase64] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { IES, isLoading } = useIES();
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const blob = await getBlob(`${IES.LOGO}`);
      //  const response = await fetch('/logo192.png');
        const reader = new FileReader();
        reader.onloadend = () => {
          setLogoBase64(reader.result as string); 
          setLoading(false);
        };
        reader.onerror = () => {
          setError('Erro ao converter imagem para base64');
          setLoading(false);
        };

        reader.readAsDataURL(blob);
      } catch (err: any) {
        setError(err.message || 'Erro inesperado');
        setLoading(false);
      }
    };

    fetchLogo();
  }, []);

  return { logoBase64, loading, error };
}
